import { render, staticRenderFns } from "./ProjectFileTagsInput.vue?vue&type=template&id=0761451a&scoped=true"
import script from "./ProjectFileTagsInput.vue?vue&type=script&lang=js"
export * from "./ProjectFileTagsInput.vue?vue&type=script&lang=js"
import style0 from "./ProjectFileTagsInput.vue?vue&type=style&index=0&id=0761451a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761451a",
  null
  
)

export default component.exports